import ModelBase from "./shared/model-base.js";

interface RecipientRef {
  type: string;
  id: number | string;
  name?: string | null;
  email?: string | null;
}

interface SubjectRef {
  type: string;
  id: number | string;
  name?: string | null;
}

interface Payload {
  title?: string;
  body?: string;
  url?: string;
  icon?: string;
  [key: string]: unknown;
}

interface ModelAttributes {
  id: string | number;
  event_type?: string;
  payload?: Payload;
  recipient?: RecipientRef | null;
  subject_ref?: SubjectRef | null;
  inmails_count?: number;
  mailing_deliveries_count?: number;
  created_at?: string;
  updated_at?: string;
}

const OPTIONS = {
  i18nModelName: "notification",
  columns: [
    "id",
    "event_type",
    "payload",
    "recipient",
    "subject_ref",
    "inmails_count",
    "mailing_deliveries_count",
    "created_at",
    "updated_at",
  ],
  editColumns: {},
};

export default class Notification extends ModelBase {
  constructor(attributes: Partial<ModelAttributes> = {}) {
    super(OPTIONS, attributes);
  }
}
